import React from 'react';
import { Typography, TableRow, TableCell } from '@mui/material';
import RenderPeriodDateRange from '../../account/reportingPeriod/RenderPeriodDateRange';

const BreakdownHeaderRow = ({ showB, aLabel, bLabel, aDate }) => {
    if (showB) {
        return (
            <TableRow>
                <TableCell width="10%" />
                <TableCell width="40%" sx={{ textAlign: 'center' }}>
                    <Typography
                        variant="caption"
                        sx={{
                            color: 'text.secondary',
                            textAlign: 'center'
                        }}
                    >
                        {aLabel}
                    </Typography>
                </TableCell>
                <TableCell width="40%" sx={{ textAlign: 'center' }}>
                    <Typography
                        variant="caption"
                        sx={{
                            color: 'text.secondary'
                        }}
                    >
                        {bLabel}
                    </Typography>
                </TableCell>
                <TableCell width="10%" />
            </TableRow>
        );
    }

    return (
        <TableRow>
            <TableCell colSpan={2} sx={{ textAlign: 'center', border: 0, p: 0, m: 0 }}>
                <Typography
                    variant="caption"
                    sx={{
                        color: 'text.secondary',
                        textAlign: 'center'
                    }}
                >
                    <RenderPeriodDateRange
                        period={aDate}
                    />
                </Typography>
            </TableCell>
        </TableRow>
    );
};

export default BreakdownHeaderRow;